<template>
  <div>
    <v-dialog ref="dialog" v-model="menu" width="290px">
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <slot v-bind="{ computedDate: computedDate }"></slot>
        </div>
      </template>
      <v-date-picker
        :disabled="disabled"
        v-model="date"
        scrollable
        @input="onInput"
        v-bind="$props"
        color="primary"
        :allowed-dates="allowedDates"
      ></v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    value: {
      default: undefined
    },
    min: {
      default: undefined
    },
    max: {
      default: undefined
    },
    allowedDates: {
      default: undefined
    },
    format: {
      default: 'DD/MM/YYYY'
    },
    disabled: {
      default: false
    }
  },
  data() {
    return {
      date: this.value,
      menu: false
    }
  },
  computed: {
    computedDate() {
      return this.value ? moment(this.value).format(this.format) : this.value
    }
  },
  methods: {
    onInput(date) {
      this.menu = false
      this.$emit('input', date)
    }
  },
  watch: {
    value() {}
  }
}
</script>

<style lang="scss" scoped></style>
